import { render, staticRenderFns } from "./ScopeOfSupply.vue?vue&type=template&id=65e7f19e&scoped=true"
import script from "./ScopeOfSupply.vue?vue&type=script&lang=js"
export * from "./ScopeOfSupply.vue?vue&type=script&lang=js"
import style0 from "./ScopeOfSupply.vue?vue&type=style&index=0&id=65e7f19e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e7f19e",
  null
  
)

export default component.exports